// extracted by mini-css-extract-plugin
export default {"Button":"Button--m0aQl","CardListSpace":"CardListSpace--uGmkN","FooterSpacing":"FooterSpacing--kjz4x"};